import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import { DialogHeader } from "../../auth/components/PasswordRecoveryModal";
// import { ErrorModal } from "./ErrorModal";
import { ActionAlert } from "./alerts/ActionAlert";
import { ConfirmationModal } from "./ConfirmationModal";
import { EditTextInfoForm } from "./EditTextInfoForm";
import * as yup from "yup";
import DangerBaseButton from "./DangerBaseButton";
import PrimaryBaseButton from "./PrimaryBaseButton";

export function EditTextInfoModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  label: string;
  title: string;
  fieldName: string;
  newInfo: string;
  setNewInfo: (userInfo: string) => void;
  schema: yup.ObjectSchema<any>;
  onConfirm: () => Promise<void>;
  confirmationModalTitle: string;
  confirmationModalContentText: string;
  successModalTitle: string;
  successModalContentText: string;
  errorModalTitle: string;
  errorModalContentText: string;
  onMount: () => void;
}) {
  const {
    open,
    setOpen,
    title,
    newInfo,
    fieldName,
    setNewInfo,
    schema,
    label,
    onConfirm,
    confirmationModalTitle,
    confirmationModalContentText,
    errorModalContentText,
    // errorModalTitle,
    successModalContentText,
    // successModalTitle,
    onMount,
  } = props;
  const [openEditConfirmationModal, setOpenEditConfirmationModal] =
    useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
  };
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "450px",
            maxHeight: "600px",
          },
        }}
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          <Typography
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
              },
              fontWeight: 500,
            }}
          >
            {title}
          </Typography>
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "auto",
          }}
          dividers
        >
          <EditTextInfoForm
            open={open}
            setCanEdit={setCanEdit}
            setNewValue={setNewInfo}
            value={newInfo}
            setOpenConfirmValueEditModal={setOpenEditConfirmationModal}
            ref={formRef}
            fieldName={fieldName}
            label={label}
            schema={schema}
          />
        </DialogContent>
        <DialogActions>
          <DangerBaseButton
            onClick={onClose}
            title="Fechar"
            sx={{
              height: "38px",
            }}
          />

          <PrimaryBaseButton
            disabled={!canEdit}
            variant="contained"
            onClick={handleFormSubmit}
            title="Editar"
            sx={{
              height: "38px",
            }}
          />
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        open={openEditConfirmationModal}
        setOpen={setOpenEditConfirmationModal}
        title={confirmationModalTitle}
        contentText={confirmationModalContentText}
        onConfirm={onConfirm}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />

      <ActionAlert
        message={successModalContentText}
        severity="success"
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        onClose={() => {
          setOpen(false);
          onMount();
        }}
      />
      <ActionAlert
        message={errorModalContentText}
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
